export { defaultColorCssVarsMap } from './colorCssVarsMap';
